/**
 * Socket.IO客户端配置
 * 完全按照参考设计的简单可靠连接机制
 */

/**
 * Socket.IO客户端配置选项
 * 
 * 超时时间策略：
 * - 客户端timeout(150秒) < 服务端pingTimeout(180秒)
 * - 让客户端先检测到超时并主动重连，避免被服务端强制断开
 * - 提供更好的用户体验和连接稳定性
 */
export const socketClientConfig = {
  // 移动端友好的Socket.IO配置
  reconnection: true,
  reconnectionAttempts: 5,         // 增加重连次数
  reconnectionDelay: 2000,         // 2秒重连延迟
  reconnectionDelayMax: 10000,     // 最大10秒延迟
  timeout: 150000,                 // 150秒超时（小于服务器PING_TIMEOUT 180秒，让客户端先检测到超时）
  forceNew: false,                 // 不强制创建新连接，允许复用
  transports: ['websocket', 'polling'],

  // 开发环境配置 - 移动端友好
  development: {
    reconnectionDelay: 2000,      // 开发环境稍快重连
    reconnectionDelayMax: 10000,  // 最大10秒延迟
    timeout: 150000               // 150秒超时（小于服务器PING_TIMEOUT 180秒）
  },

  // 生产环境配置 - 移动端优化
  production: {
    reconnectionDelay: 5000,      // 生产环境更长延迟
    reconnectionDelayMax: 30000,  // 最大30秒延迟
    timeout: 150000               // 150秒超时（小于服务器PING_TIMEOUT 180秒）
  }
};

/**
 * 获取环境相关的Socket配置
 */
export function getSocketConfig() {
  const isDevelopment = process.env.NODE_ENV === 'development';

  return {
    ...socketClientConfig,
    ...(isDevelopment ? socketClientConfig.development : socketClientConfig.production)
  };
}

/**
 * Socket事件名称常量
 */
export const SOCKET_EVENTS = {
  // 连接事件
  CONNECT: 'connect',
  DISCONNECT: 'disconnect',
  CONNECT_ERROR: 'connect_error',

  // 心跳事件
  HEARTBEAT: 'heartbeat',
  HEARTBEAT_RESPONSE: 'heartbeat_response',

  // 消息事件
  SEND_MESSAGE: 'send_message',
  AI_RESPONSE: 'ai_response',

  // 话题事件
  JOIN_TOPIC: 'join_topic',
  TOPIC_JOINED: 'topic_joined',
  TOPIC_ACTIVATED: 'topic_activated',
  TOPIC_RESUMED: 'topic_resumed',
  TOPIC_STATUS: 'topic_status',
  TOPIC_COMPLETED: 'topic_completed',

  // 会话事件
  SESSION_LIMIT_REACHED: 'session_limit_reached',
  SESSION_CONTINUE_RESPONSE: 'session_continue_response',
  MESSAGE_LIMIT_REACHED: 'message_limit_reached',

  // 评价事件
  RATING_REQUEST: 'rating_request',
  SUBMIT_RATING: 'submit_rating',
  RATING_SUBMITTED: 'rating_submitted',

  // 错误事件
  ERROR: 'error'
} as const;

/**
 * Socket连接状态
 */
export type SocketStatus = 'disconnected' | 'connecting' | 'connected' | 'reconnecting';

/**
 * 心跳数据接口（参考设计）
 */
export interface HeartbeatData {
  timestamp: number;
}